export const typography = {
  fontSize: {
    normal: "0.875rem",
    heading: "1.2rem",
    heading30: "1.875rem",
    heading36: "2.25rem",
  },
};
